import { consultNotificationSettings } from "../config/appConfig"

export const consult = (userReq) => {
    return (dispatch, _getState, { getFirebase, getFirestore }) => {
        //async call to firestore
        const firestore = getFirestore()
        firestore.collection(consultNotificationSettings.firestoreCollection).add({
            message: {
                subject: 'Service Request',
                html: consultNotificationSettings.htmlTemplate(userReq)
            },
            to: consultNotificationSettings.customerCareEmail
        }).then(() => {
            dispatch({ type: 'REQ_SUCCESS', userReq })

        })

    }
}



export const consultReducer = (state = {
    reqSent: false,
    reqError: null
}, action) => {

    switch (action.type) {
        case 'REQ_SUCCESS':
            console.log('request successfully sent');
            return {
                ...state,
                reqSent: true,
                reqError: null,
            }
        case 'REQ_ERROR':
            console.log('request error');
            return {
                ...state,
                reqSent: false,
                reqError: action.err.message,
            }

        default:
            return state
    }
}